var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-con",on:{"click":function($event){return _vm.$emit('click',_vm.menu)}}},[_c('div',{class:_vm.check?'menu-item check':'menu-item'},[_c('img',{attrs:{"src":_vm.menu.menuPic}}),_c('span',[_vm._v(_vm._s(_vm.menu.menuName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }